import Damon1IconUrl from "assets/images/damonx.jpg";
import './style.scss';

const HomePage = () => (
  <section className="home-page-container">
    <div className="home-page-container__wrapper">
      <img 
        className="home-page-container__img" 
        src={Damon1IconUrl} 
        alt="Damon Nam Portrait"
      />
    </div>
  </section>
);

export default HomePage;
